import React, { useState} from "react";
import Select, {components} from 'react-select'
import {country} from './countries';
import './selectFlags.css';

function ReactSelectFlag(props){

    const [state,setState] = useState({
        value: {
            value: 57,
            "name": "CO",
            label: "CO(+57)",
            "locale": "es-ES",
            flagPath: <img
                src={process.env.PUBLIC_URL + '/img/flags/co.svg'}
                alt=""
                className={"flag"}
            />
        },
        disabled :false
    });

    const handleState = x => setState(Object.assign({},state,x));

    const singleOption = (props) => (
        <components.Option {...props}>
            <div className={"wc f01"}>
                <div style={{flex:"0 0 20px;"}}>
                    {props.data.flagPath ? props.data.flagPath : null}
                </div>
                <div
                    style={{
                    flex:"1 0 50px",
                    maxWidth:"calc(100% - 32px)",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    paddingLeft:"10px",
                }}>
                    {props.label}
                </div>
            </div>
        </components.Option>
    );


    const singleValue = (props) => (
        <components.SingleValue {...props}>
            <div className={"f01 wc custom-container p-0"}>
                <div style={{width:"25px"}} >
                    {props.data.flagPath ? props.data.flagPath : null}
                </div>
                <div
                    className={" label-flag pt-1"}
                    style={{
                    flex:"1 0 52px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    paddingLeft:"5px",
                    width:"100%",
                    margin:"0"
                }}>
                    {props.data.label}
                </div>
            </div>
        </components.SingleValue>
    );

    const Mycaret = (props)=>(
        <components.DropdownIndicator {...props}>
            <img src={process.env.PUBLIC_URL + "/img/arrowsSelect.png"}  width={"10px"}  height={"20px"} alt=""  className={"mt-2"}/>
        </components.DropdownIndicator>
    );


    return (
        <Select
            placeholder={"Buscar"}
            classNamePrefix={"flag-select "}
            options={country}
            value={state.value}
            onChange={(data) =>{
                handleState({value:data});
                if(props.onChange){
                    props.onChange(data.value);
                }
            }}
            components={{
                Option: singleOption,
                SingleValue: singleValue,
                DropdownIndicator:Mycaret,
            }}
            styles={{
                control: (base,state) => Object.assign({},base,
                    {
                        background: state.isDisabled ? "#f5f5f9 " : "white",
                        marginBottom:0,
                        height:"35px",
                        minHeight:"35px",
                        boxShadow:"none",
                        borderColor: state.isFocused ? "#8c8c91" : state.isDisabled ? "transparent" : "#c5c5c8" ,
                        width:"100%",
                    }),

                dropdownIndicator: (base) => Object.assign({},base,
                    {
                        padding:"5px .5em",
                        height:"35px",
                        width:"15px",
                        border:"1px solid red"
                    }),
                indicatorsContainer: (base) => Object.assign({},base,
                    {
                        height:"25px",
                        padding:"10px 0 0 0",
                        width:"10px",
                    }),
                indicatorSeparator: (base) => Object.assign({},base,
                    {
                        height:"32px",
                        padding:"0",
                        width:"2px",
                    }),
                singleValue:(base) => Object.assign({},base,
                    {
                        top:"0",
                        transform:"translateY(0)",
                        height:"35px",
                        width:"100%",
                        margin:"0",
                        padding:"0",
                        maxWidth:"100%"
                    }),
                valueContainer:(base) => Object.assign({},base,
                    {
                        display:"block",
                        overflow:"visible",
                        padding:"0",
                        lineHeight:"30px",
                        border:"1px solid red"
                    }),
                container:(base) => Object.assign({},base,
                    {
                        display:"block",
                        width:"100%",
                        height:"35px",
                        flex:"1 0 95px",
                        border:"0"
                    }),
                input: (base) => Object.assign({},base,
                    {
                        top:"0",
                        transform:"translateY(0)",
                        height:"35px",
                        margin:"0",
                        width:"100%",
                    }),
                menu: (base) => Object.assign({},base,
                    {
                        maxHeight:"100px",
                        minWidth:"150px",
                        margin:"0",
                        width:"auto"
                    }),
                menuList: (base) => Object.assign({},base,
                    {
                        maxHeight:"100px",
                        margin:"0",
                        width:"auto"
                    }),
                menuitem: (base) => Object.assign({},base,
                    {
                        margin:"0",
                        width:"200px"
                    }),

            }}
            isDisabled={props.isDisabled || state.disabled}
        />
    )

}

export default React.memo(ReactSelectFlag);
